import { UserComponent } from './user.component';
import { ListComponent } from './list/list.component';
import { CrudComponent } from './crud/crud.component';
import { Routes } from '@angular/router';
import { canActivateUser, isAuthenticated } from '../../shared/guard/guard';
import { PageKey } from '../../shared/services/page/models/page.key';

export const userRoute: Routes = [{
  path: 'users',
  component: UserComponent,
  canActivate: [isAuthenticated, canActivateUser],
  children: [
    {
      path: '',
      component: ListComponent,
      data: {
        title: 'Listagem',
        key: PageKey.USERS,
      }
    },
    {
      path: 'crud',
      component: CrudComponent,
      data: { key: PageKey.CRUD, search: false }
    },
    {
      path: 'crud/:id',
      component: CrudComponent,
      data: { key: PageKey.CRUD, search: false }
    }
  ],
  data: {
    title: 'Usuários',
    key: PageKey.USERS,
  }
}]
